import React from 'react';
function AlignCenter({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M18 10H6M21 6H3M21 14H3M18 18H6" />
    </svg>
  );
}

export default AlignCenter;
